import { LightboxImage } from './Lightbox'

const VictimSection = () => {
  return (
    <section className="relative w-full bg-black overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black via-[#0a0f1a] to-black"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-8 md:pt-12 pb-6 md:pb-8">
        <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-center">
          <div className="relative">
            <LightboxImage
              src="/spoke-static/images/SPOKE_firehouse13_crew_portrait.jpg"
              alt="SPOKE film Firehouse 13 crew portrait five firefighters in navy uniforms standing in front of Engine 313"
              className="w-full rounded-lg shadow-2xl"
            />
            <div className="absolute inset-0 rounded-lg ring-1 ring-white/10 pointer-events-none"></div>
          </div>

          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-black font-montserrat uppercase tracking-wide text-white leading-tight mb-8">
              The Calls You Never Hear.<br />The Ones They Don't Talk About.
            </h2>

            <p className="text-white text-base md:text-lg leading-relaxed font-poppins font-light mb-6">
              You see firefighters washing rigs on weekends, waving from the cab, rolling past with lights and sirens. What you don't see is what follows them home. The violence. The loss. The sleepless nights. The cancer. The empty seats at the dinner table.
            </p>

            <p className="text-white text-base md:text-lg leading-relaxed font-poppins font-light">
              For generations, the fire service has built itself around showing up for everyone else at a cost few people ever see. That conversation has been smoldering for years. SPOKE is the fuel.
            </p>

          </div>
        </div>
      </div>

      <div className="relative z-10 w-full bg-black/60 py-6 md:py-10">
        <p className="text-center text-5xl md:text-7xl lg:text-8xl font-montserrat font-black uppercase tracking-wider text-yellow-400 mb-4">
          SPOKE
        </p>

        <div className="mt-20 md:mt-28 max-w-5xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-center">
            <div>
              <h3 className="text-2xl md:text-3xl lg:text-4xl font-montserrat font-black uppercase tracking-wide text-white leading-tight mb-6">
                The Cost They Pay.<br />The Job They Choose.
              </h3>
              <p className="text-white text-base md:text-lg leading-relaxed font-poppins font-light mb-4">
                Twenty-five years after 9/11, the true cost of this job is still being counted — and the young crew at Station 13 trains for it anyway.
              </p>
              <p className="text-white text-base md:text-lg leading-relaxed font-poppins font-light mb-4">
                They walked in knowing. They know the cancer risk is real. They know the calls add up. They know the work is technical, physical, and emotionally heavy.
              </p>
              <p className="text-white text-base md:text-lg leading-relaxed font-poppins font-light mb-4">
                And still, when the tones go off, they show up.
              </p>
              <p className="text-white text-base md:text-lg leading-relaxed font-poppins font-light">
                Shift after shift. Year after year. That's the expectation. That's the job.
              </p>
            </div>
            <div className="relative">
              <LightboxImage
                src="/spoke-static/images/SPOKE_firefighter_wall_breach_training.jpg"
                alt="SPOKE film firefighter breaching wall with water spray wearing Scott air pack during training"
                className="w-full rounded-lg shadow-2xl"
              />
              <div className="absolute inset-0 rounded-lg ring-1 ring-white/10 pointer-events-none"></div>
            </div>
          </div>
        </div>

        <div className="relative mt-10 md:mt-14 max-w-5xl mx-auto px-6">
          <div className="relative w-full overflow-hidden rounded-lg" style={{ aspectRatio: '2.35/1' }}>
            <LightboxImage
              src="/spoke-static/images/SPOKE_firefighters_mayday_exit_flames.jpg"
              alt="SPOKE film firefighters emerging from flaming doorway in dramatic red light with reflections on wet ground"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent pointer-events-none"></div>
            <div className="absolute bottom-0 left-0 right-0 px-6 pb-3 md:px-8 md:pb-4 pointer-events-none">
              <p className="text-[clamp(1rem,2.2vw,2.4rem)] font-montserrat font-black uppercase tracking-wide text-white leading-tight whitespace-nowrap">
                The <span className="text-red-500">Mayday</span> They Hope Never Comes
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 flex items-center justify-center gap-1">
          <div className="w-[45%] h-[2px] bg-red-600"></div>
          <div className="w-[22%] h-[2px] bg-yellow-400"></div>
        </div>
      </div>
    </section>
  )
}

export default VictimSection
